<template>
	<div class="chart">
		<BaseChart :option="baseOption" />
	</div>
</template>

<script>
	export default {
		name: 'ClueStatus',
		props: {
			xData: {
				type: Array,
				default: () => [],
			},
			barData: {
				type: Array,
				default: () => [],
			},
		},
		computed: {
			baseOption() {
				return {
					grid: {
						bottom: '20%',
						right: '5%',
						top: '5%',
						left: '5%',
					},
					tooltip: {
						trigger: 'axis',
					},
					legend: {
						data: ['新增', '跟进', '签约', '关闭'],
						bottom: '2%',
						itemWidth: 14,
						itemGap: 60,
					},
					xAxis: [
						{
							type: 'category',
							data: this.xData,
							splitLine: {
								show: true,
								lineStyle: { type: 'dashed' },
							},
						},
					],
					yAxis: {
						type: 'value',
						splitLine: {
							lineStyle: { type: 'dashed' },
						},
					},
					series: [
						{
							name: '新增',
							type: 'bar',
							stack: 'total',
							barWidth: 20,
							color: '#4080FF',
							data: [320, 302, 301, 334, 390, 330, 320],
						},
						{
							name: '跟进',
							type: 'bar',
							stack: 'total',
							color: '#16A34A',
							data: [120, 132, 101, 134, 90, 230, 210],
						},
						{
							name: '签约',
							type: 'bar',
							stack: 'total',
							color: '#FB923C',
							data: [220, 182, 191, 234, 290, 330, 310],
						},
						{
							name: '关闭',
							type: 'bar',
							stack: 'total',
							color: '#EF4444',
							data: [150, 212, 201, 154, 190, 330, 410],
						},
					],
				};
			},
		},
		methods: {},
	};
</script>

<style lang="scss" scoped>
	.chart {
		width: 100%;
		height: 100%;
	}
</style>
